// extracted by mini-css-extract-plugin
export default {"notifications_provider_container":"NotificationProvider_notifications_provider_container__u2uBA","notifications_container":"NotificationProvider_notifications_container__37456"};